import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { usePage } from '@inertiajs/inertia-react';

const MultipleRemoveFeaturedCoupons = ({checked}) => {
  const {category} = usePage().props
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'categories.multi.remove.coupon',
        text: 'Do you want to remove selected coupons?',
        id: category.category_id
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple remove coupons">
      <FontAwesomeIcon
        color={'red'}
        size={'lg'}
        icon={solid('xmark')}/>
    </button>
  );
};

export default MultipleRemoveFeaturedCoupons;
